import Taginput from './Taginput'

export default Taginput



//////////////////
// WEBPACK FOOTER
// ./node_modules/buefy/src/components/taginput/index.js
// module id = null
// module chunks = 